var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"absolute table"},[_c('alttop'),_vm._m(0),_c('bottom')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle text-white"},[_c('div',{staticClass:"container cell"})])
}]

export { render, staticRenderFns }